import Vue from 'vue'
import Router from 'vue-router'
import Landing from '@/components/Landing'
import Location from '@/components/Location'
import Page from '@/components/Page'
import Anthology from '@/components/Anthology'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/location/:slug',
      name: 'Location',
      components: {
        default: Location
      }
    },
    {
      path: '/anthology/:slug?',
      name: 'Anthology',
      components: {
        default: Anthology
      }
    },
    {
      path: '/gallery',
      name: 'Gallery',
      components: {
        default: Page
      }
    },
    {
      path: '/visitor-information/:slug?',
      name: 'Visitor Information',
      components: {
        default: Page
      }
    },
    {
      path: '/about/:slug?',
      name: 'About',
      components: {
        default: Page
      }
    },
    {
      path: '/:loc?',
      name: 'Landing',
      components: {
        default: Landing
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach ((to, from, next) => {
  store.dispatch('loadData').then(() => {
    next()
    setTimeout(function(){
      window.prerenderReady = true
    }, 1500)
  })
})

export default router
